import * as yup from "yup";

export const userSchema = yup
    .object({
        firstName: yup
            .string()
            .trim(),
        lastName: yup
            .string()
            .trim(),
        email: yup
            .string()
            .email("Il formato della email non è corretto"),
        streetAddress: yup
            .string()
            .trim(),
        city: yup
            .string()
            .trim(),
        addressNumber: yup
            .string()
            .trim(),
        cap: yup
            .string()
            .trim(),
        phone: yup
            .string()
            .trim(),
        orderNote: yup
            .string()
            .trim(),
        userProfileImage: yup
            .string()
            .trim()
    });

export const producerSchema = yup
    .object({
        email: yup
            .string()
            .email("Il formato della email non è corretto"),
        name: yup
            .string(),
        description: yup
            .string(),
        website: yup
            .string(),
        address: yup
            .string(),
        phone: yup
            .string(),
        piva: yup
            .string(),
        contactEmail: yup
            .string()
            .email("Il formato della email non è corretto"),
        referentName: yup
            .string(),
        referentEmail: yup
            .string()
            .email("Il formato della email non è corretto"),
        referentSurname: yup
            .string(),
        referentPhone: yup
            .string(),
        lat: yup
            .number().nullable(),
        long: yup
            .number().nullable(),
        mediaList: yup
            .array()
    })

export const productSchema = yup
    .object({
        name: yup
            .string()
            .required("Il nome è obbligatorio")
            .trim(),
        producerId: yup
            .string()
            .trim(),
        sku: yup
            .string()
            .trim(),
        barcode: yup
            .string()
            .trim(),
        description: yup
            .string()
            .trim(),
        shortDescription: yup
            .string()
            .trim(),
        categoryList: yup
            .array(),
        attributes: yup
            .string(),
        // .array(),
        variants: yup
            .array(),
        // .array(),
        mediaList: yup
            .array()
    });

export const editProductSchema = yup
    .object({
        name: yup
            .string()
            .trim(),
        producerId: yup
            .string()
            .trim(),
        sku: yup
            .string()
            .trim(),
        barcode: yup
            .string()
            .trim(),
        description: yup
            .string()
            .trim(),
        shortDescription: yup
            .string()
            .trim(),
        categoryList: yup
            .array(),
        attributes: yup
            .string(),
        // .array(),
        variants: yup
            .array(),
        // .array(),
        mediaList: yup
            .array()
    });

export const featuredInputSchema = yup.object({
        name: yup.string().optional(),
        description: yup.string().optional(),
        chipText: yup.string().optional(),
        startDate: yup
            .number()
            .transform((_, originalValue) =>
                originalValue ? new Date(originalValue).getTime() : undefined
            )
            .optional(),
        endDate: yup
            .number()
            .transform((_, originalValue) =>
                originalValue ? new Date(originalValue).getTime() : undefined
            )
            .optional(),
});
